import React from 'react';
import Audio from './Audio';
import Text from './Text';
import FIBText from './FIBText';
import DisplayTemplate from '../displayTemplate';

export default function TextAndAudio({ contentType, content, selected, disabled, handleAnswerSelection, enableTextToAudio, contentDisplayType, contentUrl, mediaStyle, overrideHTML, renderDefault = false, helpText, templateType, ...props }) {

    const AudioComponent = () => <Audio renderDefault={true} contentUrl={contentUrl} />;
    const TextComponent = () => contentDisplayType == 'FIB' ? <FIBText disabled={disabled} value={selected} renderDefault={true} handleAnswerSelection={handleAnswerSelection} length={props.length} content={content} /> : <Text renderDefault={true} enableTextToAudio={enableTextToAudio} content={content} helpText={helpText} />;

    return (<DisplayTemplate templateType={templateType} components={[TextComponent, AudioComponent]} {...props} />)

}